export const ERROR_CODE_KEY = 'UPLOADS_UNSUPPORTED_FILE_TYPE';

export const DEFAULT_ACCEPT = '.png';

export const VALID_FORMATS_LIST = ['image/png'];

export const ERROR_MESSAGE =
  'У файла недопустимый формат. Загрузите файл с расширением ' + DEFAULT_ACCEPT;
